module.exports = __webpack_public_path__ + "static/img/10.bbfe262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/10.png
// module id = h797
// module chunks = 0